import { render, staticRenderFns } from "./ServerGroupPermissions.vue?vue&type=template&id=497b2cda"
import script from "./ServerGroupPermissions.vue?vue&type=script&lang=js"
export * from "./ServerGroupPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports